// @ts-ignore
import React from "react";

import { JiraSoftwarePageTemplate } from "../../templates/jira-software-page/src";

export const JiraSoftwarePage = () => <JiraSoftwarePageTemplate />;
